/* globals Namespace */
(function (ns) {
    'use strict';

    /**
     * Use this component when you want to create a "fake link"
     * Add data-sl attribute with the url you want
     * Add data-sl-t="_blank" if you wish (optional)
     */

    var LNK_COMPONENT = '[data-sl]';

    /**
     * Navigate to value option url
     */
    function navigateToUrl() {
        var target = this.getAttribute('data-sl-t'),
            url = this.getAttribute('data-sl'), decodedUrl,
            adwordsId = this.getAttribute('data-gad-id'),
            adwordsLabel = this.getAttribute('data-gad-label'),
            base64Encode = this.getAttribute('data-encoded');

        if (adwordsId !== '' && adwordsLabel !== '') {
            // window.gaTrackAdwordsConversion(adwordsId, adwordsLabel, 1);
        }

        if (base64Encode === 'true') {
            decodedUrl = atob(url);
            url = decodedUrl;
        }


        let params = new URLSearchParams(window.location.href);
        let sourceType = params.get('req_source_type');

        if (sourceType){
            let urlSourceType = url.split('#');
            url = urlSourceType[0]+'?req_source_type='+sourceType+'#'+urlSourceType[1]
            console.log(url);
        }

        if (target === '_blank') {
            window.open(url);
        } else {
            window.location.href = url;
        }

    }

    /**
     * Initialize url selector component
     * Detect change event and navigate to new selected option
     */
    function initUrlSelector() {
        var $urlSelectorsList = document.querySelectorAll(LNK_COMPONENT),
            index;

        for (index = 0; index < $urlSelectorsList.length; index++) {
            $urlSelectorsList[index].setAttribute('data-url-listener','');
            $urlSelectorsList[index].addEventListener('click', navigateToUrl);
        }
    }

    initUrlSelector();
}(Namespace));
